/** Anonim oylama / geri bildirim için tarayıcı parmak izi */
export function getVisitorHash(): string {
  const key = 'kitapcik_visitor';
  let id = localStorage.getItem(key);
  if (!id) {
    id = `v_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
    localStorage.setItem(key, id);
  }
  return id;
}
